import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Checkbox,
  Breadcrumb,
  message,
  Form,
  Input,
  Modal,
} from "antd";
import { translate } from "../../../locale";
import Company from "../../../services/CompanyServices";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import FullPageLoader from "../../../components/Loaders/FullPageLoader";
import { InfoCircleOutlined } from "@ant-design/icons";
import ModalLinkHistory from "../../../components/Modals/ModalLinkHistory";
import SubscriptionServices from "../../../services/SubscriptionServices";
import SimpleReactValidator from "simple-react-validator";
import { AdminContext } from "../../../providers/AdminContext";
import DashServices from "../../../services/DashServices";

const { Title, Text } = Typography;

const SubscriptionModules = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modules, setmodules] = useState([]);
  const location = useLocation();
  const [user_modules, setuser_modules] = useState(location.state.user_modules);
  const [values, setValues] = useState({
    ...location.state.values,
    link_description: "",
    link_enterprise: "",
    link_id: "",
    link_label: "",
    link_url: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [modalHistory, showModalHistory] = useState(false);
  const { user } = useContext(AdminContext);
  const [isSuperOrAdmin, setIsSuperOrAdmin] = useState(false);
  const [modalWarningLink, setModalWarningLink] = useState(false);
  const [, forceUpdate] = useState();
  const [subModules, setSubModules] = useState({
    feedingSubModules: [],
    o2SubModules: [],
  });
  const [counter, setCounter] = useState(0);

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
    })
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsSuperOrAdmin(
      user.user.rol === "eira-super-admin" ||
        user.user.rol === "eira-company-admin"
    );
    loadData();
  }, []);

  useEffect(() => {
    const fetchFoodModule = async () => {
      try {
        const response = await DashServices.getSubscriptions(id);
        const feedingModule = response.data.subscription.modules.find(
          (subModule) => subModule.name === "Alimentacion"
        );
        if (feedingModule) {
          setSubModules((prevSubModules) => ({
            ...prevSubModules,
            feedingSubModules: feedingModule.submodules,
          }));
        }
        const O2Module = response.data.subscription.modules.find(
          (submodule) => submodule.name === "SaturacionO2"
        );

        if (O2Module) {
          setSubModules((prevSubModules) => ({
            ...prevSubModules,
            o2SubModules: O2Module.submodules,
          }));
        }
      } catch (error) {
        console.error("Error fetching modules: ", error);
      }
    };
    fetchFoodModule();
  }, []);

  const updateSubscription = async () => {
    setSaving(true);
    let selectedIds = [
      ...subModules.feedingSubModules
        .filter((subModule) => subModule.selected)
        .map((subModule) => subModule.submodule_id),
      ...subModules.o2SubModules
        .filter((subModule) => subModule.selected)
        .map((subModule) => subModule.submodule_id),
    ];

    let data = {
      subscription_id: id,
      enterprise_id: location.state.enterprise,
      name: values.name,
      // image: values.image,
      access_code: values.access_code,
      duration_days: values.duration_days,
      sensitive_data: values.sensitive_data,
      modules: [],
      submodules: selectedIds,
    };
    let hasExternalLink = false;

    for (let i = 0; i < user_modules.length; i++) {
      data.modules.push(user_modules[i].module);
      if (user_modules[i].module === 11) {
        hasExternalLink = true;
      }
    }

    try {
      const response = await Company.updateSubscription(
        data,
        data.enterprise_id
      );
      if (response.status >= 200 && response.status < 300) {
        const dataLink = {
          ...(values.link_id ? { external_link_id: values.link_id } : null), // integer,
          label: values.link_label, // string,
          description: values.link_description, // string,
          url: values.link_url, // string,
          subscriptions: [id], // [integer],
          enterprise: values.link_enterprise, // integer,
        };
        if (hasExternalLink) {
          await SubscriptionServices.updateExternalLink(dataLink);
        }
        navigate("/admin/subscriptions/" + id, {
          state: { enterprise: location.state.enterprise },
        });
      }
    } catch (error) {
      message.error(error.toString());
    } finally {
      setSaving(false);
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await Company.getmodules();
      if (response.status >= 200 && response.status < 300) {
        const rsLinks = await SubscriptionServices.getExternalLink(
          location.state.enterprise,
          id
        );

        if (
          rsLinks.status >= 200 &&
          rsLinks.status < 300 &&
          rsLinks.data.data[0] != undefined
        ) {
          setValues((v) => ({
            ...v,
            link_description: rsLinks.data.data[0].description,
            link_enterprise: rsLinks.data.data[0].enterprise,
            link_id: rsLinks.data.data[0].id,
            link_label: `Co_${location.state.enterprise}_Sub_${id}`,
            link_url: rsLinks.data.data[0].url,
          }));
        }
        setmodules(response.data.modules);
        let feedingModule = user_modules.find(
          (mod) => mod.name === "Alimentacion"
        );
        let O2Module = user_modules.find((mod) => mod.name === "SaturacionO2");

        if (feedingModule) {
          setSubModules((prevSubModules) => ({
            ...prevSubModules,
            feedingSubModules: feedingModule.submodules,
          }));
        } else {
          feedingModule = response.data.modules.find(
            (mod) => mod.type === "Alimentacion"
          );
          const updatedSubModules = feedingModule.submodules.map(
            (submodule) => ({
              ...submodule,
              selected: false,
            })
          );
          setSubModules((prevSubModules) => ({
            ...prevSubModules,
            feedingSubModules: updatedSubModules,
          }));
        }
        if (O2Module) {
          setSubModules((prevSubModules) => ({
            ...prevSubModules,
            o2SubModules: O2Module.submodules,
          }));
        } else {
          O2Module = response.data.modules.find(
            (mod) => mod.type === "SaturacionO2"
          );
          const updatedSubModules = O2Module.submodules.map((submodule) => ({
            ...submodule,
            selected: false,
          }));
          setSubModules((prevSubModules) => ({
            ...prevSubModules,
            o2SubModules: updatedSubModules,
          }));
        }
      }
    } catch (error) {
      message.error(error.toString());
    } finally {
      setLoading(false);
    }
  };

  const FindItem = (module) => {
    let exist = false;
    user_modules.forEach((itm) => {
      if (itm.module === module.id) {
        exist = true;
      }
    });
    return exist;
  };

  const handleSelect = (item) => {
    let exist = user_modules.find((elem) => elem.module == item.id);

    if (item.type === "Alimentacion" && exist) {
      const updatedArray = subModules.feedingSubModules.map((item) => {
        return { ...item, selected: false };
      });
      setSubModules((prevSubModules) => ({
        ...prevSubModules,
        feedingSubModules: updatedArray,
      }));
    }

    if (item.type === "SaturacionO2" && exist) {
      const updatedArray = subModules.o2SubModules.map((item) => {
        return { ...item, selected: false };
      });
      setSubModules((prevSubModules) => ({
        ...prevSubModules,
        o2SubModules: updatedArray,
      }));
    }
    if (exist) {
      let index = user_modules.indexOf(exist);
      setuser_modules(
        user_modules.slice(0, index).concat(user_modules.slice(index + 1))
      );
    } else {
      setuser_modules((v) => [
        ...v,
        {
          module: item.id,
          name: item.type,
        },
      ]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleClick = (e) => {
    if (counter === 0 || !isSuperOrAdmin) {
      setModalWarningLink(true);
    }
    setCounter(counter + 1);
  };

  const handleOnChangeInput = async (event, it) => {
    const { checked } = event.target;

    // Activate feeding module if not is activated
    if (
      it !== "Frecuencia respiratoria" &&
      checked &&
      !user_modules.find((mod) => mod.name === "Alimentacion")
    ) {
      const moduleToActivate = modules.find(
        (mod) => mod.type === "Alimentacion"
      );
      handleSelect(moduleToActivate);
      FindItem(moduleToActivate);
    }

    setSubModules((prevSubModules) => ({
      ...prevSubModules,
      feedingSubModules: prevSubModules.feedingSubModules.map((subModule) =>
        subModule.label.toLowerCase() === it.toLowerCase()
          ? { ...subModule, selected: checked }
          : subModule
      ),
    }));
    if (checked && !user_modules.find((mod) => mod.name === "SaturacionO2")) {
      if (it === "Frecuencia respiratoria") {
        const moduleToActivate = modules.find(
          (mod) => mod.type === "SaturacionO2"
        );
        handleSelect(moduleToActivate);
        FindItem(moduleToActivate);
      }
    }
    setSubModules((prevSubModules) => ({
      ...prevSubModules,
      o2SubModules: prevSubModules.o2SubModules.map((subModule) =>
        subModule.label.toLowerCase() === it.toLowerCase()
          ? { ...subModule, selected: checked }
          : subModule
      ),
    }));
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Col className="gutter-row" span="24">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/admin">{translate("Inicio")}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/admin/subscriptions">{translate("Suscripciones")}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/admin/subscriptions/${id}`}>
              {translate("Editar suscripción")}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{translate("Activar módulos")}</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
      <Col span={24} className="my-4">
        <Title level={2} className="text-center">
          {translate("Activar módulos")}
        </Title>
      </Col>

      <Row gutter={[16, 32]} className="mt-8">
        {modules &&
          modules.length > 0 &&
          modules.map((item, index) => (
            <Col key={index} span={6}>
              <Checkbox
                className="mr-4"
                onChange={() => handleSelect(item)}
                checked={FindItem(item)}
              >
                <Text level={4} className="font-medium underline decoration-1">
                  {item.label}
                </Text>
              </Checkbox>
              {item.items != null &&
                item.items.map((it, ind) => (
                  <Row className="ml-4" key={ind}>
                    {item.type === "Alimentacion" ? (
                      <Col className="flex flex-row">
                        {it === "calorias" ? (
                          <>
                            <input
                              type="checkbox"
                              checked={
                                subModules.feedingSubModules.length > 0 &&
                                subModules.feedingSubModules.some(
                                  (subModule) =>
                                    subModule.label === "Calorias" &&
                                    subModule.selected
                                )
                              }
                              onChange={(e) => handleOnChangeInput(e, it)}
                            />
                            <div className="ml-4">{it}</div>
                          </>
                        ) : it === "carbohidratos" ? (
                          <>
                            <input
                              type="checkbox"
                              checked={
                                subModules.feedingSubModules.length > 0 &&
                                subModules.feedingSubModules.some(
                                  (subModule) =>
                                    subModule.label === "Carbohidratos" &&
                                    subModule.selected
                                )
                              }
                              onChange={(e) => handleOnChangeInput(e, it)}
                            />
                            <div className="ml-4">{it}</div>
                          </>
                        ) : (
                          it === "creditos" && (
                            <>
                              <input
                                type="checkbox"
                                checked={
                                  subModules.feedingSubModules.length > 0 &&
                                  subModules.feedingSubModules.some(
                                    (subModule) =>
                                      subModule.label === "Creditos" &&
                                      subModule.selected
                                  )
                                }
                                onChange={(e) => handleOnChangeInput(e, it)}
                              />
                              <div className="ml-4">{it}</div>
                            </>
                          )
                        )}
                      </Col>
                    ) : item.type === "SaturacionO2" ? (
                      <Col className="flex flex-row">
                        {it === "Frecuencia respiratoria" ? (
                          <>
                            <input
                              type="checkbox"
                              checked={
                                subModules.o2SubModules.length > 0 &&
                                subModules.o2SubModules.some(
                                  (subModule) =>
                                    subModule.label ===
                                      "Frecuencia Respiratoria" &&
                                    subModule.selected
                                )
                              }
                              onChange={(e) => handleOnChangeInput(e, it)}
                            />
                            <div className="ml-4">{it}</div>
                          </>
                        ) : (
                          <>
                            <div className="h-2 w-2 bg-custom_darkgray rounded-full mt-2" />
                            <div className="ml-4">{it}</div>
                          </>
                        )}
                      </Col>
                    ) : (
                      <Col className="flex flex-row">
                        <div className="h-2 w-2 bg-custom_darkgray rounded-full mt-2" />
                        <div className="ml-4">{it}</div>
                      </Col>
                    )}
                  </Row>
                ))}
              {item.type === "Telemedicina" && (
                <Form className="ml-4 mt-2">
                  <Form.Item>
                    <div className="flex flex-row space-x-2 items-center">
                      <InfoCircleOutlined
                        onClick={() => showModalHistory(true)}
                      />
                      {isSuperOrAdmin && (
                        <Input
                          name="link_url"
                          value={values.link_url}
                          placeholder={translate("Inserte link")}
                          allowClear={true}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onClick={handleClick}
                        />
                      )}
                      {!isSuperOrAdmin && (
                        <Text
                          className="border border-solid border-custom_gray bg-custom_lightgray rounded py-1 px-2 w-full truncate"
                          onClick={handleClick}
                        >
                          {values.link_url}
                        </Text>
                      )}
                    </div>
                  </Form.Item>
                </Form>
              )}
            </Col>
          ))}
      </Row>

      <Row className="justify-center mt-8">
        <Col>
          <PrimaryButton
            onClick={() => updateSubscription()}
            className="px-10"
            loading={saving}
          >
            {translate("Guardar")}
          </PrimaryButton>
        </Col>
      </Row>

      <ModalLinkHistory
        visible={modalHistory}
        onCancel={() => showModalHistory(false)}
        subscription={{
          enterprise_id: parseInt(location.state.enterprise),
          id: parseInt(id),
        }}
      />

      <Modal
        open={modalWarningLink}
        footer={[
          <PrimaryButton
            key="ok_button"
            onClick={() => setModalWarningLink(false)}
          >
            {translate("Aceptar")}
          </PrimaryButton>,
        ]}
      >
        {!isSuperOrAdmin && (
          <Text>
            {translate(
              "Usted no tiene permiso de edición. Solo los administradores pueden editar el link de teleconsulta. Consulte con soporte si desea utilizar esta función."
            )}
          </Text>
        )}
        {isSuperOrAdmin && (
          <Text>
            {translate(
              "Cuidado, la edición de este link afectará el funcionamiento de telemedicina. ¿Esta seguro que desea editar?"
            )}
          </Text>
        )}
      </Modal>

      {loading && <FullPageLoader />}
    </div>
  );
};
export default SubscriptionModules;
